import { Button } from "@mui/material";
import { DataArray } from "@mui/icons-material";
import { isSuperUser } from "../util/active_user_context";
import React from "react";

type NetsXmlButtonProps = {
    style?: React.CSSProperties;
} & ({ transactionId: string; savedCardId?: never } | { savedCardId: number; transactionId?: never });

/**
 * Button to open the Nets XML query page for a transaction or saved card.
 * Only visible to super users.
 */
export function NetsXmlButton({ transactionId, savedCardId, style }: NetsXmlButtonProps) {
    if (!isSuperUser()) return null;

    const href = transactionId
        ? `/api/admin/nets/query?transactionId=${transactionId}`
        : `/api/admin/nets/query-card?savedCardId=${savedCardId}`;

    return (
        <Button component="a" href={href} target="_blank" startIcon={<DataArray />} style={style}>
            Nets XML
        </Button>
    );
}
